import { memoize, map, pickBy, omitBy, isEmpty } from "lodash";
import moment from "moment";
import handleError from "@composables/handleError.js";
import useMyFetch from "@stores/useMyFetch";
import { useSurveyStore } from "@stores/survey/survey";

let abortController = new AbortController();

// ^ memoizes requests to cut down on back end memory load
const fetchChartsFilteredData = memoize(
  async ({ filters, ranks, target, surveyToken, customBases, only, includeNumeric }) => {
    filters = omitBy(
      Object.fromEntries(
        map(filters, (qfilters, question) => {
          return [question, pickBy(qfilters)];
        }),
      ),
      isEmpty,
    );
    if (surveyToken) {
      abortController.abort();
      abortController = new AbortController();
      try {
        const body = { filters, ranks, target };
        if (customBases && Object.keys(customBases).length > 0) {
          body.custom_bases = customBases;
        }
        if (only) {
          body.only = only;
        }
        if (includeNumeric) {
          body.include_numeric = true;
        }
        const { data } = await useMyFetch(`${useSurveyStore().resultsApiPath}/charts`, {
          headers: {
            "Content-Type": "application/json",
          },
        })
          .post(JSON.stringify(body), { signal: abortController.signal })
          .json();
        return {
          data,
          status: "DONE",
        };
      } catch (err) {
        if (err.code === "ERR_CANCELED") {
          return {
            data: {},
            status: "CANCELED",
          };
        } else {
          handleError(err);
        }
      }
    }
  },
  (arg) =>
    `${moment().startOf("hour").toDate()}/${arg.surveyToken}/${JSON.stringify(arg.filters)}/${JSON.stringify(
      arg.ranks,
    )}/${JSON.stringify(arg.target)}/${arg.surveyUpdatedAt}/${JSON.stringify(arg.customBases || {})}/${arg.only || "all"}/${arg.includeNumeric || false}`,
);

function clearChartsCache() {
  fetchChartsFilteredData.cache.clear?.();
}

export {
  clearChartsCache,
  fetchChartsFilteredData,
};
